<div class="row m-2">
    <div class="col-lg-6 col-md-10 col-sm-12 col-xs-12 mx-auto">
        <h2 class="titulo m-4">BMI Calculator</h2>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="fondoItem" [ngClass]="{ 'sexoDesactivo': sexo === 'Femenino' }">
                    <div class="contenedor" style="cursor: pointer" (click)="masculino()">
                        <i class="fas fa-mars sexo"></i>
                        <p>Masculino</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="fondoItem" [ngClass]="{ 'sexoDesactivo': sexo === 'Masculino' }">
                    <div class="contenedor" style="cursor: pointer" (click)="femenino()">
                        <i class="fas fa-venus sexo"></i>
                        <p>Femenino</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                <div class="fondoItem">
                    <div class="contenedor">
                        <p>Altura</p>
                        <div class="estiloNumero"> {{ altura }} 
                            <span class="cm">cm</span>
                        </div>
                        <input 
                            type="range" 
                            [value]="altura" 
                            min="120" 
                            max="220" 
                            class="form-range"
                            (input)="cambiarAltura($event)"
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <div class="fondoItem">
                    <div class="contenedor">
                        <p>Peso</p>
                        <div class="estiloNumero">
                            {{ peso }}
                        </div>
                        <div>
                            <i class="fas fa-minus sumaResta" (click)="peso = peso - 1"></i>
                            <i class="fas fa-plus sumaResta" (click)="peso = peso + 1"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6  col-sm-6 col-xs-6">
                <div class="fondoItem">
                    <div class="contenedor">
                        <p>Edad</p>
                        <div class="estiloNumero">
                            {{ edad }}
                        </div>
                        <div>
                            <i class="fas fa-minus sumaResta" (click)="edad = edad - 1"></i>
                            <i class="fas fa-plus sumaResta" (click)="edad = edad + 1"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <button 
                    class="btn btn-primary btn-block btn-color"
                    (click)="calcularBMI()"
                >
                    CALCULAR
                </button>
            </div>
        </div>
    </div>
</div>